<script lang="ts">
type Props = {
	path: string
}

let { path }: Props = $props()
</script>

<svg viewBox="0 0 24 24" role="presentation">
	<path d={path} />
</svg>

<style lang="postcss">
svg {
	@apply h-[1em] w-[1em] fill-current;
}
</style>
